import { render, staticRenderFns } from "./registrogarantia.vue?vue&type=template&id=3f48b6e6&"
import script from "./registrogarantia.vue?vue&type=script&lang=js&"
export * from "./registrogarantia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports